export default "__VITE_ASSET__Bz_3lDBd__"